export default "__VITE_ASSET__eypU8rW___"